import { render, staticRenderFns } from "./InvestorOnboardingReceiptPayments.vue?vue&type=template&id=664fa8a0&scoped=true&"
import script from "./InvestorOnboardingReceiptPayments.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingReceiptPayments.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingReceiptPayments.vue?vue&type=style&index=0&id=664fa8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664fa8a0",
  null
  
)

export default component.exports